import {Link} from 'react-router-dom'
import RoleDataTable from './RoleDataTable'
import UnAuthorized from 'app/custom//UnAuthorized'

import {useTranslation} from 'react-i18next'
import { useAuth } from '../core/Auth'

const RoleList = () => {
  const {t} = useTranslation()
  const {hasPermission} = useAuth()

  return hasPermission('roles-list') ? (
    <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
      <div className='card-header'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>{t('GLOBAL.LIST_', {name: t('MENU.ROLES')})}</h3>
        </div>
        <div className='d-flex align-items-center py-1'>
          {hasPermission('role-create') && (
            <Link className='btn btn-primary btn-sm align-self-center fw-bold' to={'/role/create'}>
              <i className='fas fa-plus px-1'></i>
              {t('BUTTONS.ADD_', {name: t('LABEL.ROLE')})}
            </Link>
          )}
        </div>
      </div>
      <div className='card-body p-9'>
        <RoleDataTable
          headers={[
            {
              headerName: t('GLOBAL.NUMBER'),
              sort: 'id',
            },
            {
              headerName: t('LABEL.ROLE'),
              sort: 'name',
            },
            {
              headerName: t('LABEL.PERMISSIONS'),
              sort: 'permissions',
            },
            {
              headerName: t('GLOBAL.ACTION'),
              sort: 'action',
            },
          ]}
          columns={['id', 'name', 'systems', 'permissions', 'action']}
        />
      </div>
    </div>
  ) : (
    <UnAuthorized />
  )
}

export default RoleList
